import {toAbsoluteUrl} from './AssetHelpers'

export const getImageURL = (url: string, accessToken: string) => {
  if (url && accessToken) {
    return url + `?token=${accessToken}&itemType=profile`
  }
  return toAbsoluteUrl('/media/avatars/blank.png')
}
